import { getCSSVariableValue } from './_scrolling.js';

/**
 * Anchor Links
 *
 * This script is used to handle clicks on links with anchors and scroll to the corresponding
 * anchor or redirect to a different page if the link points to a different domain.
 */
const anchorLinks = document.querySelectorAll('a[href*="#"]:not([href="#"])');

anchorLinks.forEach((link) => {
  link.addEventListener("click", (el) => {
    el.preventDefault();

    let target = el.target;
    let linkNode = target.nodeName === "A" ? target : target.parentNode;
    let href = linkNode.getAttribute("href");

    // Check if the href is only a hash (i.e., it doesn't contain a full URL)
    if (href.startsWith("#")) {
      let hash = href.slice(1);
      const element = document.getElementById(hash);

      if (!element) {
        console.error(`No element found with id "${hash}"`);
        return;
      }

      const offset = element.getBoundingClientRect().top + window.scrollY;

      // Get the --navigationYOffset variable from CSS and subtract it from the offset
      const navigationYOffset = getCSSVariableValue('--navigationYOffset');

      window.scrollTo({
        top: offset - navigationYOffset - 40,
        behavior: "smooth",
      });
    } else {
      const url = new URL(href, location.origin);
      const current_url = new URL(location.href);
      let hash = url.hash.slice(1);

      if (current_url.pathname !== url.pathname) {
        window.location = url;
      } else {
        const element = document.getElementById(hash);

        if (!element) {
          console.error(`No element found with id "${hash}"`);
          return;
        }

        const offset = element.getBoundingClientRect().top + window.scrollY;

        // Get the --navigationYOffset variable from CSS and subtract it from the offset
        const navigationYOffset = getCSSVariableValue('--navigationYOffset');

        window.scrollTo({
          top: offset - navigationYOffset - 40,
          behavior: "smooth",
        });
      }
    }
  });
});

window.addEventListener("load", function () {
  const current_url = new URL(location.href);

  if (window.location.hash) {
    let hash = current_url.hash.slice(1);
    const element = document.getElementById(hash);

    // Remove the hash from the URL
    history.replaceState("", document.title, window.location.pathname);

    if (element && element.nodeName === "FORM") {
      window.scrollTo({
        top: window.pageYOffset,
        behavior: "smooth",
      });
      return;
    }

    if (!element) {
      console.error(`No element found with id "${hash}"`);
      return;
    }

    const offset = element.getBoundingClientRect().top + window.scrollY;

    // Get the --navigationYOffset variable from CSS and subtract it from the offset
    const navigationYOffset = getCSSVariableValue('--navigationYOffset');

    // Scroll to the anchor element
    window.scrollTo({
      top: offset - navigationYOffset,
      behavior: "smooth",
    });
  }
});